import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Carousel1.css";
import tours from "../../API/tours";
import Loading from "../loading/Loading";

const Carousel = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const joinersTours = tours.filter((tour) => tour.typeOfTour === "Joiners");

  const handleNavigate = (name) => {
    setLoading(true);
    const formattedName = name.toLowerCase().replace(/\s+/g, "-"); // Format name to URL-friendly

    setTimeout(() => {
      navigate(`/tours/${formattedName}`);
      window.scrollTo(0, 0);
      setLoading(false);
    }, 1000); // Simulating a short delay for loading effect
  };

  return (
    <div className="carousel1MainCon">
      {loading && <Loading />}

      <section className="carousel-section container">
        <div className="carousel-bg"></div>
        <h2>Joiners Tour</h2>
        <p className="carousel-subtext">
          Perfect for solo travelers or small groups looking to explore with new
          friends. Join our exciting tours and experience unforgettable
          adventures!
        </p>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={10}
          slidesPerView={3}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
        >
          {joinersTours.map((tour) => (
            <SwiperSlide key={tour.id}>
              <div
                className="carousel-item"
                onClick={() => handleNavigate(tour.name)}
                style={{ cursor: "pointer" }}
              >
                <img
                  src={tour.imgArray[0]} // Get the first image from imgArray
                  alt={tour.name}
                  className="carousel-img"
                  loading="lazy"
                />
                <div className="carousel-text">
                  <h3>{tour.name}</h3>
                  <p>{tour.desc}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
    </div>
  );
};

export default Carousel;
